import React, { type ReactElement, useEffect, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { EntReportPreview } from '../../features';
import { entReportsActions } from '../../features/EntitlementReports/data-store';
import ReportModal from '../../features/ViolationsReport/components/ReportModal';

/**
 * Layout for the Entitlement Report page
 */
function EntitlementReport(): ReactElement {
  const location = useLocation();
  const dispatch = useDispatch();
  const [showReportModal, setShowReportModal] = useState(false);

  useEffect(() => {
    batch(() => {
      dispatch(entReportsActions.setReportError({ state: false }));
    });
  }, [location, dispatch]);

  return (
    <>
      <EntReportPreview setShowReportModal={setShowReportModal} />
      <ReportModal
        isOpen={showReportModal}
        setIsOpen={setShowReportModal}
        isViewAllReport
      />
    </>
  );
}

export default EntitlementReport;
